module.exports = __webpack_public_path__ + "static/media/galerija_2017 (15).a236be7d.jpg";